import Vue from "vue";
import App from "./App.vue";
import router from "./router"; // 引入路由配置

import "./assets/common.css";
import "./assets/fonts/fonts.css";

import "./utils/rem.js";

import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
